import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Widget from "../../../../../components/prefabricated/Widget";
import CIRTLogo from "../../../../../assets/images/logo-cirt-condensed-dark.svg"
import InsiderThreatBanner from "../../../../../assets/images/Insider-Threat.svg";
import TileOrderNewAttackOnDemand from "../../../../../components/customBreachBits/metrics/TileOrderNewAttackOnDemand";
import TileInsiderCountAttacksPending
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksPending";
import TileInsiderCountAttacksReady
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksReady";
import TileInsiderCountAttacksCompleted
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksCompleted";
import TileInsiderCountAttacksDefended
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksDefended";
import TileInsiderCountAttacksPartialBreach
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksPartialBreach";
import TileInsiderCountAttacksBreach
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksBreach";
import TileInsiderCountAttacksAborted
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksAborted";
import TileInsiderCountAttacksOnDemand
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountAttacksOnDemand";
import TileInsiderCountInternalAssessments
    from "../../../../../components/customBreachBits/metrics/TileInsiderCountInternalAssessments";

const BreachBoardOverviewTab = ({children, onChangeActiveTab}, props) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // const {boardActiveTab} = useSelector(({misc}) => misc);
    // const {onChangeActiveTab} = props;
    // const dispatch = useDispatch();
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    return (
        <div className={`bb-breachboard-overview`}>
            <div className="row">
                <div className={"col-2 align-self-center"}>
                    <div className={"mx-0 px-0"}>
                        <Tooltip title={"Continuous Intelligent Red Team"}>
                            <div style={{backgroundImage: `url(${CIRTLogo})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: "85px"}} />

                        </Tooltip>
                    </div>


                </div>
                <div className={"col-6 align-self-center"}>
                    <div className={"mx-0 px-0"}>
                        <div style={{backgroundImage: `url(${InsiderThreatBanner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                    </div>
                </div>
                <div className={"col-4 align-self-center"}>
                    {/*<CIRTContinuousControlWidget customerId={customerInView}/>*/}
                    <h3>A View from the Inside <Tooltip title={"The Insider Threat module displays what hackers could see and do from inside your company, either because they are already in your network or because they have legitimate access as a member of your team. The Insider Threat is the most dangerous breach approach. As with all BreachBits activities, all attacks are benign versions of real-world attacks that adhere to our Safety Promise."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                    <p>Conduct self-directed Insider Attacks.  Each attack includes a limited objective while simultaneously observing your internal attack surface.</p>

                </div>

            </div>
            <hr/>
            <div className={"tourStep-InsiderOverviewWidgets"}>
                {/*<h3>Key Risk Indicators <Tooltip title={"These Key Risk Indicators (KRIs) represent the most critical indications of your cybersecurity risk."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>*/}
                {/*<p>The Insider Threat module is self-directed.  Order Attacks on Demand to test specific hosts or to initiate limited-objective attack activity.</p>*/}
                <div className="row">
                    <div className={"col-2"} >

                    </div>
                    <div className={"col-2"} >
                        <Widget styleName={"bg-lightest-gray mx-0 px-1 py-1 pb-0 mb-0 tourStep-InsiderQuickAdd"}>


                            <div className="row">
                                <div className="col-12">
                                    <TileOrderNewAttackOnDemand/>
                                </div>
                            </div>
                            <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Quick Add</h2>
                            <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>Order an Insider Attack</p>

                        </Widget>
                    </div>


                    <div className="col-6" style={{cursor: "pointer"}} onClick={(event, newValue) => onChangeActiveTab(1)}>
                        <Widget styleName={"mx-0 px-1 py-1 mb-0 tourStepVectorsOverview"}>
                            <div className="row">

                                <div className="col-4 tourStep-AttacksPendingWidget">
                                    <TileInsiderCountAttacksPending/>
                                </div>
                                <div className="col-4 tourStep-AttacksReadyWidget">
                                    <TileInsiderCountAttacksReady/>
                                </div>
                                {/*<Divider orientation="vertical" flexItem style={{marginRight: -1, marginLeft: -1}}/>*/}
                                <div className="col-4 tourStep-AttacksCompletedWidget">
                                    <TileInsiderCountAttacksCompleted/>
                                </div>
                            </div>
                            <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Insider Attacks</h2>
                            <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>Track and view outcomes of your Insider Attacks</p>
                        </Widget>
                    </div>
                    {/*<div className="col-4" >*/}
                    {/*    <Widget styleName={"bg-lightest-gray mx-0 px-1 py-1 pb-0 mb-0 tourStep-AttackSurfaceOverview"}>*/}
                    {/*        <div className="row">*/}
                    {/*            <div className="col-6">*/}
                    {/*                <TileComingSoon/>*/}
                    {/*            </div>*/}
                    {/*            <div className="col-6">*/}
                    {/*                <TileComingSoon/>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Attack Surface</h2>*/}
                    {/*        <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>What can be seen from the inside</p>*/}
                    {/*    </Widget>*/}
                    {/*</div>*/}

                    {/*<div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mx-0 px-1 py-0" style={{cursor: "pointer"}} onClick={(event, newValue) => dispatch(boardChangeActiveTab(3))}>*/}
                    {/*    <Widget styleName={"bg-lightest-gray mx-0 px-1 py-1 mb-0 tourStepControlsOverview"}>*/}
                    {/*        <div className="row">*/}
                    {/*            <div className="col-12">*/}
                    {/*                <TileComingSoon/>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Controls</h2>*/}
                    {/*        <p className={"text-center bb-font-fridge"}>Attack obstructions</p>*/}
                    {/*    </Widget>*/}

                    {/*</div>*/}

                </div>
            </div>
            <div className="row mt-4">
                <div className={"col-2 tourStep-NumAoDWidget"}>
                    <TileInsiderCountAttacksOnDemand />
                </div>
                <div className={"col-2 tourStep-NumInternalAssessmentsWidget"}>
                    <TileInsiderCountInternalAssessments />
                </div>

                <div className={"col-2"}>
                    <TileInsiderCountAttacksDefended />
                </div>
                <div className={"col-2"}>
                    <TileInsiderCountAttacksPartialBreach />
                </div>
                <div className={"col-2"}>
                    <TileInsiderCountAttacksBreach />
                </div>
                <div className={"col-2"}>
                    <TileInsiderCountAttacksAborted />
                </div>
            </div>
        </div>
    )
};

BreachBoardOverviewTab.propTypes = {
};

export default BreachBoardOverviewTab;

